export const oopQuestions = [
  {
    id: 1,
    question: "Explain the four pillars of Object-Oriented Programming",
    parts: [
      {
        type: "text",
        content: `**OOP Pillars**

1. 🔒 Encapsulation: bundle and hide internal state
2. 🧰 Abstraction: expose essentials, hide complexity
3. 🧬 Inheritance: is-a relationships, reuse behavior
4. 🎭 Polymorphism: same interface, different implementations

Benefits: maintainability, reusability, scalability.`
      }
    ]
  },
  {
    id: 2,
    question: "What is the difference between class and prototype-based inheritance?",
    parts: [
      {
        type: "text",
        content: `**Class vs Prototype Inheritance**

**Class-based**
- 🧱 Blueprints → instances
- 📚 Classical inheritance (Java/C++/Python)

**Prototype-based (JavaScript)**
- 🧩 Objects inherit via prototype chain
- ✨ ES6 \`class\` is syntax over prototypes`
      },
      {
        type: "code",
        language: "javascript",
        content: "// Prototype\nfunction Person(name) { this.name = name; }\nPerson.prototype.greet = function() { return 'Hi'; }\n\n// Class syntax\nclass PersonC {\n  constructor(name) { this.name = name; }\n  greet() { return 'Hi'; }\n}"
      }
    ]
  },
  {
    id: 3,
    question: "What are SOLID principles?",
    parts: [
      {
        type: "text",
        content: `**SOLID Principles**

1. SRP: Single Responsibility — one reason to change
2. OCP: Open/Closed — extend without modifying existing code
3. LSP: Liskov Substitution — subtypes must be substitutable
4. ISP: Interface Segregation — prefer specific interfaces
5. DIP: Dependency Inversion — depend on abstractions

Benefits: maintainability, testability, flexibility, scalability.`
      }
    ]
  },
  {
    id: 4,
    question: "Explain composition vs inheritance",
    parts: [
      {
        type: "text",
        content: `**Composition vs Inheritance**

**Inheritance**
- 🧬 is-a relationship
- ⚠️ Tighter coupling, deep hierarchies risk

**Composition**
- 🧱 has-a relationship
- 🔀 Loose coupling, flexible behavior mixing

Guidance: favor composition for mixed behaviors/testability; use inheritance for clear hierarchies.`
      },
      {
        type: "code",
        language: "javascript",
        content: "// Inheritance\nclass Bird extends Animal { fly() {} }\n\n// Composition\nclass BirdC {\n  constructor() {\n    this.flyBehavior = new FlyWithWings();\n  }\n}"
      }
    ]
  },
  {
    id: 5,
    question: "What are KISS and DRY principles and why do we use them?",
    parts: [
      {
        type: "text",
        content: `**KISS & DRY**

**KISS (Keep It Simple, Stupid)**
- Simple, clear solutions
- Easier to read, maintain, debug
- Prefer simplicity to avoid complexity and bugs

**DRY (Don't Repeat Yourself)**
- Avoid duplication; extract common logic

Guidance: balance both; refactor on third duplication; code for humans.`
      },
      {
        type: "code",
        language: "javascript",
        content: "// KISS example\nconst getValue = (obj) => obj?.user?.profile?.name ?? 'Unknown';\n\n// DRY example\nfunction getFullName(person) {\n  return person.firstName + ' ' + person.lastName;\n}"
      }
    ]
  },
  {
    id: 6,
    question: "Give examples of basic design patterns used in JavaScript",
    parts: [
      {
        type: "text",
        content: `**Common JS Design Patterns**

- Module, Singleton, Factory, Observer
- Strategy, Decorator, Prototype, Command, Facade
- Promise-based async patterns

Use patterns to solve real problems; avoid over-engineering.`
      },
      {
        type: "code",
        language: "javascript",
        content: "// Module\nconst Counter = (function() {\n  let count = 0;\n  return {\n    increment() { count++; },\n    decrement() { count--; },\n    getCount() { return count; }\n  };\n})();\n\n// Singleton\nconst Database = (function() {\n  let instance;\n  const createInstance = () => ({ connection: 'Connected' });\n  return { getInstance() { if (!instance) instance = createInstance(); return instance; } };\n})();\n\n// Observer\nclass EventEmitter {\n  constructor() { this.events = {}; }\n  on(event, cb) { (this.events[event] ||= []).push(cb); }\n  emit(event, data) { (this.events[event] || []).forEach(cb => cb(data)); }\n}"
      }
    ]
  }
];

